<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import NavigationWrapper from "@/components/NavigationWrapper";
import { formatHashrate, getBreakpoint } from "@/utils";

export default {
  // Included components
  components: {
    FontAwesomeIcon,
    NavigationWrapper,
  },

  computed: {
    // Mapped vuex state
    ...mapGetters(["can"]),
    ...mapState(["facilities"]),
  },

  // On creation fetch the team's groups and their statistics and hashrate
  async created() {
    await this.getFacilities();
  },

  methods: {
    // Helper methods and mapped vuex actions
    formatHashrate,
    getBreakpoint,
    ...mapActions(["getFacilities"]),
  },
};
</script>

<template>
  <NavigationWrapper>
    <template #breadcrumbs>
      <b-breadcrumb-item active>Facilities</b-breadcrumb-item>
    </template>
    <b-row class="mb-3">
      <b-col cols="7">
        <h1>Facilities</h1>
      </b-col>
    </b-row>

    <b-row v-if="Object.keys(facilities).length === 0">
      <b-col>
        <b-card class="text-center py-5">
          <b-card-title>No Facilites</b-card-title>
          <b-card-text>
            Facilities are a way to keep track of your miners by location.
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col
        lg="6"
        v-for="(facility, index) in Object.values(facilities)"
        :key="index"
      >
        <b-card class="Group-card Card-hoverable">
          <b-link :to="`/facilities/${facility.id}`">
            <b-card-title>
              <div class="Group-card-title">
                {{ facility.name }}
                <span class="Group-card-link-indicator">
                  <font-awesome-icon icon="chevron-right" size="xs" />
                </span>
              </div>
            </b-card-title>
          </b-link>
        </b-card>
      </b-col>
    </b-row>
  </NavigationWrapper>
</template>

<style scoped>
.Group-card {
  margin-bottom: 2rem;
}

.Group-card-title {
  display: flex;
  align-items: center;
}

.Facilities-span {
  font-size: 275%;
}

.Group-card .Group-card-link-indicator {
  display: inline-flex;
  align-items: center;

  opacity: 0;

  transition: all 200ms;
}

.Group-card:hover .Group-card-link-indicator {
  opacity: 1;

  margin-left: 0.35rem;
}

.Group-card a {
  color: unset;
  font-weight: unset;
  text-decoration: unset;
}

.Group-card:hover .Group-card-title {
  color: #007bff;
}
</style>
